/*** Created by qfintern on 18/04/2018  ***/

const localBaseUrl = 'http://pharma-be.local';
const prodBaseUrl = 'https://prod-be.appomobile.ch'
const stagingBaseUrl = 'https://stage-be.appomobile.ch'

const baseUrl = stagingBaseUrl;

const requestConfig = {
    base_url: baseUrl,
    grant_type: 'password',
    client_id: '1_3bcbxd9e24g0gk4swg0kwgcwg4o8k8g4g888kwc44gcc0gwwk4',
    client_secret: '4ok2x70rlfokc8g0wws8c8kwcokw80k44sg48goc0ok4w0so0k'
};

export default requestConfig;



// WEBPACK FOOTER //
// ./src/api-config.js